export const DATE_FORMAT = "DD.MM.YYYY.";
export const DATE_TIME_FORMAT_LONG = "DD.MM.YYYY. HH:mm:ss";
export const DATE_TIME_FORMAT_SHORT = "DD.MM.YYYY. HH:mm";
export const TIME_FORMAT_SHORT = "HH:mm";